export default "__VITE_ASSET__7add9aa2__"